import React from "react";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import DtvText from "@directv-digital/dds.ui.dtv-text";
import { ModalTopSectionProps } from "../../package-carousel.props";

const styles = {
  topSectionStyles: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start"
  },
  offerRibbonStyles: {
    p: "2px 4px",
    borderRadius: "2px",
    mb: "2px",
    fontSize: "12px !important",
    width: "fit-content"
  },
  strikeThroughPriceStyles: {
    textDecoration: "line-through",
    fontSize: "12px !important"
  }
};

const ModalTopSection = (props: ModalTopSectionProps) => {
  const { title, subHeading, offerRibbon, strikeThroughPrice, priceText } =
    props;
  try {
    return (
      <DtvBox sx={{ ...styles.topSectionStyles }}>
        {/* Title */}
        {title?.content && <DtvText {...title} sx={{ mb: "24px" }} />}
        {/* Subheading */}
        {subHeading?.content && (
          <DtvBox sx={{ mb: "16px" }}>
            {subHeading?.content && (
              <DtvText {...subHeading} display="inline" />
            )}
            {subHeading?.spanText?.content && (
              <DtvText
                {...subHeading?.spanText}
                content={`&nbsp;${  subHeading?.spanText?.content}`}
                display="inline"
              />
            )}
          </DtvBox>
        )}
        {/* Offer Ribbon */}
        {offerRibbon?.content && (
          <DtvText
            {...offerRibbon}
            sx={{
              ...styles.offerRibbonStyles,
              background: offerRibbon?.background
            }}
          />
        )}
        {/* Strike Through Price */}
        {strikeThroughPrice?.content && (
          <DtvText
            {...strikeThroughPrice}
            sx={{ ...styles.strikeThroughPriceStyles }}
          />
        )}
        {/* Price */}
        {priceText?.content && (
          <DtvBox>
            {priceText?.content && (
              <DtvText
                {...priceText}
                sx={{
 display: "inline",
fontWeight: "bold"
}}
              />
            )}
            {priceText?.spanText?.content && (
              <DtvText
                {...priceText?.spanText}
                sx={{
 display: "inline",
fontWeight: "bold"
}}
              />
            )}
            {priceText?.legal?.content && (
              <DtvText {...priceText?.legal} display="inline" />
            )}
          </DtvBox>
        )}
        {priceText?.bodyText?.content && (
          <DtvText
            {...priceText?.bodyText}
          />
        )}
      </DtvBox>
    );
  } catch (error) {
    return <ErrorDisplay component="ModalTopSection" error={error} />;
  }
};

export default React.memo(ModalTopSection);
